import React, { useEffect } from 'react';
import { Grid, GridRow, GridColumn, Suspense, Loader, useApi } from '@axiom/ui';
import { useNavigate, useParams } from 'react-router';

import { EngagementCarousel } from '../EngagementCarousel/EngagementCarousel';
import { DiscoverTalentCarousel } from '../DiscoverTalentCarousel/DiscoverTalentCarousel';
import { SavedTalentCarousel } from '../SavedTalentCarousel/SavedTalentCarousel';
import { BrowseTalent } from '../BrowseTalent/BrowseTalent';
import { UserApi } from '../../api/user-api';
import { isClientUser } from '../../utils/roles-util';
import { localStorageUtil } from '../../utils/local-storage-util';

export const MyAxiomLandingPage = () => {
  const [{ data: user }] = useApi(UserApi.readUser());
  const navigate = useNavigate();
  const { accountId } = useParams();

  // First-login client users created via the HubSpot intake flow are sent to the intake intro,
  // unless the intro has already been shown on this browser (set by ClientIntent).
  const isFirstLogin =
    !!user.firstLoginAt && user.firstLoginAt === user.lastLoginAt;
  const introAlreadyShown =
    localStorageUtil.intakeIntroShown(user.id).get() === true;
  const shouldRedirectToIntake =
    !!accountId &&
    isClientUser(user) &&
    isFirstLogin &&
    !!user.contact?.hubspotIntake &&
    !introAlreadyShown;

  useEffect(() => {
    if (shouldRedirectToIntake) {
      void navigate(`/account/${accountId}/intake/intro`, { replace: true });
    } else if (!isFirstLogin && introAlreadyShown) {
      // Past the first-login window: the one-shot intro signal is no longer needed, so clean it up.
      localStorageUtil.intakeIntroShown(user.id).clear();
    }
  }, []);

  return shouldRedirectToIntake ? null : (
    <Grid name="LANDING_PAGE">
      <GridRow gutterBottom="24px">
        <GridColumn>
          <Suspense pendingFallback={<Loader type="spinner" />}>
            <EngagementCarousel />
          </Suspense>
        </GridColumn>
      </GridRow>

      <GridRow gutterBottom="24px">
        <GridColumn>
          <Suspense pendingFallback={<Loader type="spinner" />}>
            <DiscoverTalentCarousel />
          </Suspense>
        </GridColumn>
      </GridRow>

      <GridRow gutterBottom="24px">
        <GridColumn>
          <Suspense pendingFallback={<Loader type="spinner" />}>
            <SavedTalentCarousel />
          </Suspense>
        </GridColumn>
      </GridRow>

      <BrowseTalent />
    </Grid>
  );
};
